module.exports = __webpack_public_path__ + "img/T617.e98c2c0b.jpg";